import {
  RichCardLogo,
  RichCardLogoContainer,
  StyledRichCardFooter,
} from '@/features/listing/components/rich-card/styled'

export type RichCardFooterProps = {
  isHighlight: boolean
  logoSrc?: string
}

export const RichCardFooter = ({ isHighlight = false, logoSrc }: RichCardFooterProps) => (
  <StyledRichCardFooter $isHighlight={isHighlight}>
    {logoSrc ? (
      <RichCardLogoContainer>
        <RichCardLogo
          data-testid="rich-card-logo"
          alt=""
          srcImage={{ src: logoSrc }}
          skipNextImage
        />
      </RichCardLogoContainer>
    ) : null}
  </StyledRichCardFooter>
)
